// @flow

import React from 'react';

import Spinner from '../Components/Spinner';
import { logError } from './Logger';

export default function renderOrDisplayErrorPage({ props, element, error }: { props: ?Object, element: React$Element<any>, error: ?Error }) {
  const isLoading = props === null;

  if (error) {
    logError(error);
    return <div>{'Error occured...'}</div>;
  }

  return isLoading ? <Spinner /> : React.cloneElement(element, props);
}



// WEBPACK FOOTER //
// ./src/js/libs/RenderOrDisplayErrorPage.js